import { render, staticRenderFns } from "./replayData.vue?vue&type=template&id=fb944954&scoped=true"
import script from "./replayData.vue?vue&type=script&lang=js"
export * from "./replayData.vue?vue&type=script&lang=js"
import style0 from "./replayData.vue?vue&type=style&index=0&id=fb944954&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb944954",
  null
  
)

export default component.exports